import { Link } from 'react-router-dom';
import { getHotArticles, getLatestArticles } from '@/mocks/articles';
import { categoryMap } from '@/mocks/categories';
import ArticleCard from '@/components/feature/ArticleCard';

export default function ArticleSections() {
  const hotArticles = getHotArticles().slice(0, 3);
  const latestArticles = getLatestArticles(6);

  return (
    <>
      <section className="w-full py-12 md:py-16 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-3">
              <span className="w-2 h-6 bg-primary-500 rounded-full" />
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                热门推荐
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {hotArticles.map((article) => (
              <ArticleCard
                key={article.id}
                id={article.id}
                title={article.title}
                excerpt={article.excerpt}
                coverImage={article.coverImage}
                categoryId={article.categoryId}
                categoryName={categoryMap[article.categoryId]?.name || ''}
                author={article.author}
                publishedAt={article.publishedAt}
                viewCount={article.viewCount}
                isHot={article.isHot}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-3">
              <span className="w-2 h-6 bg-secondary-500 rounded-full" />
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                最新文章
              </h2>
            </div>
            <Link
              to="/category/zixun"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              查看全部
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {latestArticles.map((article) => (
              <ArticleCard
                key={article.id}
                id={article.id}
                title={article.title}
                excerpt={article.excerpt}
                coverImage={article.coverImage}
                categoryId={article.categoryId}
                categoryName={categoryMap[article.categoryId]?.name || ''}
                author={article.author}
                publishedAt={article.publishedAt}
                viewCount={article.viewCount}
                isHot={article.isHot}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}